.ux-date-range-picker {
  display: block;
  overflow: visible;
  position: relative;

  .ux-date-picker {
    flex: 0 1 auto;
  }

  .ux-date-picker__field-wrapper .ux-label {
    white-space: nowrap;
  }

  &__separator {
    align-items: center;
    display: flex;
    flex: 0 0 20px;
    justify-content: center;
  }

  &__container {
    align-items: stretch;
    display: flex;
    flex-flow: row nowrap;
    justify-content: stretch;
  }
}

.ux-date-range-picker--kind-form {
  .ux-date-range-picker__separator {
    font-size: 0;
    opacity: 0;
  }
}

@media (width <= 425px) {
  .ux-date-range-picker .ux-date-picker {
    flex: 1 1 auto;
    width: 100%;
  }

  .ux-date-range-picker__container {
    align-items: stretch;
    flex-direction: column;
    justify-content: stretch;
  }

  .ux-date-picker .ux-date-picker__container {
    left: 0;
    right: 0;
    width: auto;
  }
}

@media (width >= 426px) and (width <= 639px) {
  .ux-date-picker:first-child .ux-date-picker__container {
    left: 0;

    [dir="rtl"] & {
      left: auto;
      right: 0;
    }
  }

  .ux-date-picker:last-child .ux-date-picker__container {
    right: 0;

    [dir="rtl"] & {
      left: 0;
      right: auto;
    }
  }
}
